/** @jsx jsx */
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import defaultsDeep from 'lodash/defaultsDeep';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { Container, Column, Row } from '../../../styles/Grid';
import createButtonCss from '../../ui/Button';
import Spacer from '../../ui/Spacer';
import { modalIds, ModalsConsumer } from '../../../contexts/ModalsContext';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import {
  containerPaddingCss,
  containerMarginCss,
  TitleText,
  SubtitleText,
  columnStyles,
  Line,
} from './index.styles';

const defaultData = {
  BackgroundColor: '',
  Title: {},
  Description: {},
};

export class Promo extends SafePureComponent {
  safeRender() {
    const { props } = this;
    const fields = defaultsDeep(props.fields, defaultData);
    const { t } = props;
    const { BackgroundColor, Title, Description } = fields;

    return (
      <Spacer
        backgroundColor={BackgroundColor}
        marginCss={containerMarginCss}
        paddingCss={containerPaddingCss}
      >
        <Container>
          <Row>
            <Column cols={{ sm: 6, md: 6, lg: 7, xl: 7 }} offsets={{ lg: 1 }}>
              <TitleText>
                <Text field={Title} />
              </TitleText>
              <SubtitleText>
                <Text field={Description} />
              </SubtitleText>
            </Column>
            <Column
              cols={{ sm: 6, md: 2, lg: 2, xl: 2 }}
              offsets={{ lg: 1 }}
              css={columnStyles}
            >
              <ModalsConsumer>
                {({ openModal }) => (
                  <button
                    onClick={() => openModal(modalIds.enquiry)}
                    css={createButtonCss()}
                  >
                    {t('BookNow')}
                  </button>
                )}
              </ModalsConsumer>
            </Column>
            <Column cols={{ md: 8, lg: 10, xl: 10 }} offsets={{ lg: 1 }}>
              <Line />
            </Column>
          </Row>
        </Container>
      </Spacer>
    );
  }
}

Promo.displayName = 'Promo';

Promo.propTypes = {
  fields: PropTypes.shape({
    Title: PropTypes.shape({
      value: PropTypes.string,
    }),
    Description: PropTypes.shape({
      value: PropTypes.string,
    }),
    BackgroundColor: PropTypes.shape({
      value: PropTypes.string,
    }),
  }),
};

export default withNamespaces()(Promo);
